import React, { useEffect, useState } from 'react';
import { console_ } from '../services/api';
import { dateFr, dateHeureFr } from '../services/format';
import { Erreur, Chargement, messageErreur } from './Ui';

// Mentions présentées aux clients, versionnées : la version en vigueur est
// figée dans chaque preuve ; on ne modifie jamais, on publie une nouvelle version.
export default function Mentions({ user }) {
  const admin = user.role === 'admin';
  const [mentions, setMentions] = useState(null);
  const [finalites, setFinalites] = useState([]);
  const [erreur, setErreur] = useState('');
  const [edition, setEdition] = useState(null); // { finalite_code, texte, en_vigueur_du }
  const [historique, setHistorique] = useState({});

  const charger = () => console_.mentions().then((r) => setMentions(r.data)).catch((e) => setErreur(messageErreur(e)));
  useEffect(() => { charger(); console_.config().then((r) => setFinalites(r.data.finalites)).catch(() => {}); }, []);

  if (erreur && !mentions) return <Erreur message={erreur} />;
  if (!mentions) return <Chargement />;

  const groupes = [null, ...finalites.map((f) => f.code)].map((code) => ({
    code, libelle: code ? (finalites.find((f) => f.code === code)?.libelle || code) : 'Mention générale (information Art. 13)',
    versions: mentions.filter((m) => (m.finalite_code || null) === code),
  }));

  const publier = async (e) => {
    e.preventDefault();
    try {
      await console_.creerMention({ finalite_code: edition.finalite_code || null, texte: edition.texte, en_vigueur_du: edition.en_vigueur_du || null });
      setEdition(null); setErreur(''); charger();
    } catch (e2) { setErreur(messageErreur(e2)); }
  };

  return (
    <div>
      <h1 className="rg-titre-page">Mentions</h1>
      <Erreur message={erreur} />
      <p className="rg-info" style={{ marginBottom: 16 }}>Variables disponibles : {'{societe}'}, {'{dpo_email}'}. Une nouvelle version s'applique aux demandes ouvertes après sa date d'entrée en vigueur ; les preuves existantes conservent leur texte.</p>
      {groupes.map((g) => {
        const courante = g.versions[0];
        return (
          <section className="rg-section" key={g.code || 'generale'}>
            <h2>{g.libelle}<small>{g.code || 'generale'}</small></h2>
            <div className="rg-bloc">
              {courante ? (
                <>
                  <p style={{ margin: '0 0 8px', whiteSpace: 'pre-wrap' }}>{courante.texte}</p>
                  <p className="rg-info">Version {courante.version} · en vigueur depuis le {dateFr(courante.en_vigueur_du)} · publiée le {dateHeureFr(courante.created_at)}{courante.cree_par ? ` par ${courante.cree_par}` : ''}</p>
                </>
              ) : <p className="rg-info">Aucune mention : la finalité est présentée par son libellé seul.</p>}
              <div className="rg-actions">
                {admin && <button className="rg-btn rg-btn--principal" onClick={() => setEdition({ finalite_code: g.code, texte: courante?.texte || '', en_vigueur_du: '' })}>Nouvelle version</button>}
                {g.versions.length > 1 && <button className="rg-btn" onClick={() => setHistorique({ ...historique, [g.code]: !historique[g.code] })}>{historique[g.code] ? 'Masquer' : 'Voir'} les {g.versions.length - 1} versions antérieures</button>}
              </div>
              {historique[g.code] && (
                <table className="rg-tableau" style={{ marginTop: 12 }}>
                  <thead><tr><th>Version</th><th>En vigueur du</th><th>Texte</th></tr></thead>
                  <tbody>{g.versions.slice(1).map((v) => <tr key={v.id}><td>v{v.version}</td><td>{dateFr(v.en_vigueur_du)}</td><td style={{ whiteSpace: 'pre-wrap' }}>{v.texte}</td></tr>)}</tbody>
                </table>
              )}
              {edition && edition.finalite_code === g.code && (
                <form className="rg-form" style={{ marginTop: 12 }} onSubmit={publier}>
                  <label>Texte de la version {(courante?.version || 0) + 1}<textarea value={edition.texte} onChange={(e) => setEdition({ ...edition, texte: e.target.value })} required /></label>
                  <label>Entrée en vigueur (vide = aujourd'hui)<input type="date" value={edition.en_vigueur_du} onChange={(e) => setEdition({ ...edition, en_vigueur_du: e.target.value })} /></label>
                  <div className="rg-actions">
                    <button className="rg-btn rg-btn--principal">Publier</button>
                    <button type="button" className="rg-btn" onClick={() => setEdition(null)}>Annuler</button>
                  </div>
                </form>
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
